import { getApp, getApps, initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAIA1RExTd0tjoKITZWk_NxfZyjDMqSISg",
  authDomain: "royalcurryleaf-ma.firebaseapp.com",
  projectId: "royalcurryleaf-ma",
  storageBucket: "royalcurryleaf-ma.firebasestorage.app",
  messagingSenderId: "610114834943",
  appId: "1:610114834943:web:d1153a633828c1bc5317ca",
  measurementId: "G-ZW8WY2FJ2Q",
};

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const storage = getStorage(app);

// Initialize Analytics only in browser environment
let analytics = null;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { app, firestore, storage, analytics };
